import React from 'react';
import { SortFilterModal, SortField, HAS_VALUE_SENTINEL, NO_VALUE_SENTINEL } from './data-lists/SortFilterModal';
import { useLocale } from '../contexts/LocaleContext';

/** Thin Contacts-flavored wrapper around the generic SortFilterModal — kept
 * so ContactsList.tsx/ContactExportFieldsModal.tsx don't need to change
 * their imports, while the actual UI/logic now lives in one shared place
 * any module's list screen can use. Re-exports the sentinels under their
 * original names for those two callers. */

export { HAS_VALUE_SENTINEL, NO_VALUE_SENTINEL };
export type ContactSortField = SortField;

interface ContactSortFilterModalProps {
  visible: boolean;
  onClose: () => void;
  sortFields: SortField[];
  sortBy: string | null;
  sortOrder: 'asc' | 'desc';
  onChangeSort: (sortBy: string | null, sortOrder: 'asc' | 'desc') => void;
  customFieldKeys: string[];
  customFieldFilters: Record<string, string[]>;
  onChangeCustomFieldFilters: (filters: Record<string, string[]>) => void;
  fieldValueOptions: Record<string, string[]>;
  loadingFieldValues: string | null;
  onExpandField: (fieldId: string, isFixedField: boolean) => void;
}

export const ContactSortFilterModal: React.FC<ContactSortFilterModalProps> = (props) => {
  const { t } = useLocale();
  return (
    <SortFilterModal
      {...props}
      labels={{
        modalTitle: t('contacts.sort.modalTitle'),
        sortTitle: t('contacts.sort.sortTitle'),
        filterTitle: t('contacts.sort.filterTitle'),
        filterHint: t('contacts.sort.filterHint'),
        hasValue: t('contacts.sort.hasValue'),
        noValueOption: t('contacts.sort.noValueOption'),
        searchFieldsPlaceholder: t('contacts.sort.searchFieldsPlaceholder'),
        searchValuesPlaceholder: t('contacts.sort.searchValuesPlaceholder'),
        reset: t('contacts.sort.reset'),
        anyValue: t('contacts.sort.anyValue'),
        selected: t('contacts.sort.selected'),
        noValues: t('contacts.sort.noValues'),
        noValuesMatchSearch: t('contacts.sort.noValuesMatchSearch'),
        noFieldsMatch: t('contacts.sort.noFieldsMatch'),
        apply: t('contacts.filter.location.apply'),
      }}
    />
  );
};
